import axios from "axios";

// url for testing locally defined in .env file
// const url = process.env.URL;
const url = "https://xmeme-rishabh.herokuapp.com/memes";

// defines all functions mapped to api requests
export const fetchPosts = () => axios.get(url);
export const createPost = (newPost) => axios.post(url, newPost);
export const likePost = (id) => axios.patch(`${url}/${id}/likePost`);
export const updatePost = (id, updatedPost) =>
  axios.patch(`${url}/${id}`, updatedPost);
export const deletePost = (id) => axios.delete(`${url}/${id}`);
